import React from 'react'

import GetStarted from '../components/get-started'
import GetStartedPanel from '../components/get-started-panel'
import Layout from '../components/layout'
import SiteWrapper from '../components/sitewrapper'
import TwoColumns, {
  Column,
  OuterBox,
  InnerBox,
} from '../components/two-columns'
import styles from '../component-styles/get-started.module.scss'

export default function GetStartedPage(): React.ReactElement {
  return (
    <SiteWrapper twoPanelsSignUp grey noFooter uplifterNavBar>
      <Layout width={960} className={styles.layout}>
        <TwoColumns className={styles.columns}>
          <Column main transparent equal className={styles.mainColumn}>
            <div className={styles.mainColumnInner}>
              <GetStarted />
            </div>
          </Column>
          <Column side transparent equal className={styles.sideColumn}>
            <OuterBox panel>
              <InnerBox className={styles.topBox}>
                <GetStartedPanel />
              </InnerBox>
            </OuterBox>
          </Column>
        </TwoColumns>
      </Layout>
    </SiteWrapper>
  )
}

// <SiteWrapper skeleton uplifterNavBar>
//   <Layout style={{ paddingTop: 30 }} width={980}>
//
//   </Layout>
// </SiteWrapper>
